import React, { useState } from "react";
import { InputType } from "../../Utils/Utils";
import Image from "./Image";
import { SvgImages } from "../../Utils/LocalImages";

function CustomTextFieldTwo({
  name,
  register,
  labelTitle,
  placeholder,
  inputType,
  additionalClasses,
  icon,
  showError,
  errorMessage,
  labelTitleText,
  showMandatory = false,
  imageClass,
  labelClass,
  ...props
}) {
  const [useType, setUseType] = useState(inputType);

  return (
    <div className="form-group mb-3 d-flex flex-column">
      <label htmlFor={name} className={`login_heading fw-600 ${labelClass}`}>
        {labelTitle}
        {showMandatory ? (
          <span className={`danger ${labelTitleText ? "filelebeltext" : ""}`}>
            {labelTitleText || "*"}
          </span>
        ) : null}
      </label>
      <div className={`${useType === "file" ? additionalClasses : ""} position-relative`}>
        {icon && <Image src={icon} className={`input_icons ${imageClass}`} />}
        {useType === "day" ? (
          <select
            className={`${additionalClasses} form-control coform-control`}
            {...props}
            {...(register ? register(name) : {})}
          >
            <option value="">Select a day</option>
            <option value="Sunday">Sunday</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
          </select>
        ) : useType === "time" ? (
          <input
            type="time"
            className={`${additionalClasses} form-control coform-control`}

            {...props}
            {...(register ? register(name) : {})}
          />
        ) : (
          <input
            type={useType}
            className={`${useType === "file" ? "" : `${additionalClasses} form-control coform-control`}
              } ${inputType === InputType.password ? "pe-5" : ""}`}
            onFocus={() => { name }}
            onBlur={() => { name }}
            placeholder={placeholder}
            {...props}
            {...(register ? register(name) : {})}
          />
        )}
        {inputType === InputType.password && (
          <Image
            className="eye_icon cursor-pointer"
            src={
              useType !== InputType.password
                ? SvgImages.password_show
                : SvgImages.password_hide
            }
            onClick={() => {
              setUseType(
                useType === InputType.password ? InputType.text : InputType.password
              );
            }}
          />
        )}
      </div>

      {showError && (
        <span className="danger fs-14 fw-400 mt-1">{errorMessage}</span>
      )}
    </div>
  );
}

export default CustomTextFieldTwo;
